import { useState } from 'react';
import Image from 'next/image';

// Add this above your main component
const ResultImage: React.FC<{ thumbnail?: string; title: string }> = ({
  thumbnail,
  title,
}) => {
  const [hasError, setHasError] = useState(false);

  if (!thumbnail || hasError) return null;

  const imageUrl = thumbnail.startsWith('http')
    ? thumbnail
    : `${process.env.NEXT_PUBLIC_SITE_URL}${thumbnail}`;

  return (
    <Image
      height={150}
      width={200}
      src={imageUrl}
      alt={title}
      className="result-img"
      onError={() => setHasError(true)} // hide image if it fails
    />
  );
};

export default ResultImage;
